import * as React from 'react';

export default function useForceUpdate() {
    const [value, setValue] = React.useState<number>(0);
    return () => setValue((value) => value + 1);
}
